var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countItems >= _vm.perPage)?_c('pagination',{attrs:{"count-text":"Mostrando {from} a {to} de {count} registros","page":_vm.page,"records":_vm.countItems,"per-page":_vm.perPage,"theme":_vm.theme},on:{"paginate":_vm.emitEvent}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }